<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.TransactionCode }}</td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeShip"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeShip | currency('', 2)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeShip"
                        type="number"
                        label="Phí ship"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">edit</v-icon>
                  <v-icon v-if="userRole === 1" medium @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
      <v-dialog v-model="dialogEditTranCode" persistent max-width="700px">
        <v-card>
          <v-card-title>
            <span class="title">Cập nhật vận đơn #{{currentItem.ID}}</span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã vận đơn"
                  ref="trancode"
                  v-model="currentItem.TransactionCode"
                  class="input-group--focused"
                  :rules="requireRules"
                  @keyup.enter="saveData"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeShip"
                  :decimal="0"
                  label="Phí vận chuyển"
                  class="input-group--focused"
                  @press_enter="saveData"
                ></h-currency-input>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogEditTranCode = false">Đóng</v-btn>
            <v-btn color="blue darken-1" text @click="saveData">Lưu lại</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import createPermissionMixin from "@/mixins/permissionMixin";
import _ from "lodash";

export default {
  mixins: [createPermissionMixin('store_cn')],
  components: {
    "hpo-filter": Filtering,
    "store-popup": store
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.storeManager.all.data,
      total_rows: state => state.storeManager.all.total,
      currentItem: state => state.storeManager.selected,
      loading: state => state.storeManager.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("storeManager/getList", param);
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("storeManager/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$store.commit("storeManager/setDetail", {
        data: {
          ID: 0,
          TransactionCode: "",
          FeeShip: 0
        }
      });
      this.dialogStoreManager = true;
    },
    saveItem(item) {
        this.$store.dispatch("storeManager/setDetail", {
          data: item,
          id: item.ID
        });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    }
  },
  mounted() {
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("storeManager/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
